import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private apiUrl = `${environment.baseUrl}auth/login`;
  private adminApiUrl = `${environment.baseUrl}auth/admin/login`;
  constructor(private http: HttpClient) { }

  login(data: any): Observable<any> {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    console.log("Hostname--->", hostname);
    const isAdmin = environment.impersonateAsSuperAdmin ? true : hostname.startsWith('admin');
    console.log("Is Admin Login--->", isAdmin);
    const url = isAdmin ? this.adminApiUrl : this.apiUrl;
    console.log("Login URL--->", url);
    return this.http.post(url, data);
  }

  impersonateLogin(token: string): Observable<any> {
    return this.http.post(`${environment.baseUrl}auth/impersonate-login`, { token });
  }

  impersonate(propertyId: string): Observable<any> {
    return this.http.post(`${environment.baseUrl}auth/impersonate`, { property_id: propertyId });
  }

  exitImpersonation(): Observable<any> {
    return this.http.post(`${environment.baseUrl}auth/exit-impersonation`, {});
  }
}
